
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './common/guards/auth.guard';

import { PublicComponent } from './common/layouts/public/public.component';
import { PUBLIC_ROUTES } from './common/layouts/public/public.routes';
import { SecureComponent } from './common/layouts/secure/secure.component';
import { SECURE_ROUTES } from './common/layouts/secure/secure.routes';
import { GuestComponent } from './guest/guest.component';


const APP_ROUTES: Routes = [
  { path: '', redirectTo: 'main/results', pathMatch: 'full' },
  // { path: 'home', component: PublicComponent, data: { title: 'Public Views' }, children: PUBLIC_ROUTES },
  { path: 'main', component: SecureComponent, data: { title: 'Secure Views' }, children: SECURE_ROUTES },
  // { path: 'guest', component: GuestComponent, pathMatch: 'full' },
  { path: '**', redirectTo: 'main/results'}
];

@NgModule({
    imports: [
        RouterModule.forRoot(APP_ROUTES, { enableTracing: false })
    ],
    exports: [RouterModule],
    providers: []
})
export class AppRoutingModule { }
